import { SVGProps } from 'react';

interface IProps extends SVGProps<SVGSVGElement> {
  pathProps?: SVGProps<SVGPathElement>;
}

const CheckmarkSharpIcon = ({ pathProps, ...props }: IProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.9526 5.90309L9.0477 19.5087L3.03906 13.5001L4.49747 12.0417L8.94724 16.4915L19.4005 4.54492L20.9526 5.90309Z"
      fill="currentColor"
      {...pathProps}
    />
  </svg>
);

export default CheckmarkSharpIcon;
